import React from 'react';

/**
 * Modern Glassmorphism KPI Cards with Click-to-Filter and Sentinel Alert Pulse
 */
export default function RiskMetricsCards({
  metrics,
  filterStatus = 'all',
  setFilterStatus,
  filterSeverityGroup = 'all',
  setFilterSeverityGroup,
  isMobile = false
}) {
  const { total = 0, pending = 0, investigating = 0, resolvedOrClosed = 0, sentinel = 0 } = metrics || {};

  const handleTotalClick = () => {
    setFilterStatus?.('all');
    setFilterSeverityGroup?.('all');
  };

  const handlePendingClick = () => {
    setFilterSeverityGroup?.('all');
    setFilterStatus?.(filterStatus === 'pending' ? 'all' : 'pending');
  };

  const handleInvestigatingClick = () => {
    setFilterSeverityGroup?.('all');
    setFilterStatus?.(filterStatus === 'investigating' ? 'all' : 'investigating');
  };

  const handleResolvedClick = () => {
    setFilterSeverityGroup?.('all');
    // If already resolved, toggle to closed or all
    if (filterStatus === 'resolved') {
      setFilterStatus?.('closed');
    } else if (filterStatus === 'closed') {
      setFilterStatus?.('all');
    } else {
      setFilterStatus?.('resolved');
    }
  };

  const handleSentinelClick = () => {
    setFilterStatus?.('all');
    setFilterSeverityGroup?.(filterSeverityGroup === 'sentinel' ? 'all' : 'sentinel');
  };

  const isTotalActive = filterStatus === 'all' && filterSeverityGroup === 'all';
  const isPendingActive = filterStatus === 'pending';
  const isInvestigatingActive = filterStatus === 'investigating';
  const isResolvedActive = filterStatus === 'resolved' || filterStatus === 'closed';
  const isSentinelActive = filterSeverityGroup === 'sentinel';

  return (
    <div className="risk-metrics-grid">
      {/* 1. Total */}
      <div
        className={`risk-metric-card risk-metric-card--total ${isTotalActive ? 'risk-metric-card--active' : ''}`}
        onClick={handleTotalClick}
        title="คลิกเพื่อดูทั้งหมด"
      >
        <div className="risk-metric-title" style={{ color: '#475569' }}>
          <span>📋</span>
          <span>อุบัติการณ์ทั้งหมด</span>
        </div>
        <div className="risk-metric-val" style={{ color: '#0f172a' }}>
          {total}
        </div>
        <div className="risk-metric-sub">
          {isTotalActive ? '✓ แสดงทั้งหมด' : 'บันทึกในระบบ'}
        </div>
      </div>

      {/* 2. Pending */}
      <div
        className={`risk-metric-card risk-metric-card--pending ${isPendingActive ? 'risk-metric-card--active' : ''}`}
        onClick={handlePendingClick}
        title="คลิกเพื่อกรองสถานะ: รอตรวจสอบ"
      >
        <div className="risk-metric-title" style={{ color: '#b45309' }}>
          <span>🟡</span>
          <span>รอตรวจสอบ</span>
        </div>
        <div className="risk-metric-val" style={{ color: '#d97706' }}>
          {pending}
        </div>
        <div className="risk-metric-sub" style={{ color: '#b45309' }}>
          {isPendingActive ? '✓ กำลังกรองสถานะนี้' : 'ยังไม่เริ่ม RCA'}
        </div>
      </div>

      {/* 3. Investigating */}
      <div
        className={`risk-metric-card risk-metric-card--investigating ${isInvestigatingActive ? 'risk-metric-card--active' : ''}`}
        onClick={handleInvestigatingClick}
        title="คลิกเพื่อกรองสถานะ: กำลังสอบสวน RCA"
      >
        <div className="risk-metric-title" style={{ color: '#1d4ed8' }}>
          <span>🔵</span>
          <span>กำลังสอบสวน RCA</span>
        </div>
        <div className="risk-metric-val" style={{ color: '#2563eb' }}>
          {investigating}
        </div>
        <div className="risk-metric-sub" style={{ color: '#1d4ed8' }}>
          {isInvestigatingActive ? '✓ กำลังกรองสถานะนี้' : 'วิเคราะห์สาเหตุเชิงระบบ'}
        </div>
      </div>

      {/* 4. Resolved / Closed */}
      <div
        className={`risk-metric-card risk-metric-card--resolved ${isResolvedActive ? 'risk-metric-card--active' : ''}`}
        onClick={handleResolvedClick}
        title="คลิกเพื่อกรองสถานะ: แก้ไขแล้ว / ปิดเคส"
      >
        <div className="risk-metric-title" style={{ color: '#15803d' }}>
          <span>🟢</span>
          <span>แก้ไขแล้ว / ปิดเคส</span>
        </div>
        <div className="risk-metric-val" style={{ color: '#16a34a' }}>
          {resolvedOrClosed}
        </div>
        <div className="risk-metric-sub" style={{ color: '#15803d' }}>
          {isResolvedActive ? `✓ ${filterStatus === 'closed' ? 'ปิดเคสแล้ว' : 'แก้ไขแล้ว'}` : 'ดำเนินการเสร็จสิ้น'}
        </div>
      </div>

      {/* 5. Sentinel Alert */}
      <div
        className={`risk-metric-card risk-metric-card--sentinel ${sentinel > 0 ? 'risk-metric-card--sentinel-alert' : ''} ${isSentinelActive ? 'risk-metric-card--active' : ''}`}
        onClick={handleSentinelClick}
        title="คลิกเพื่อกรองเฉพาะระดับ Sentinel Event"
      >
        <div className="risk-metric-title" style={{ color: sentinel > 0 ? '#b91c1c' : '#64748b' }}>
          <span>🚨</span>
          <span>Sentinel Alert</span>
        </div>
        <div className="risk-metric-val" style={{ color: sentinel > 0 ? '#dc2626' : '#64748b' }}>
          {sentinel}
        </div>
        <div className="risk-metric-sub" style={{ color: sentinel > 0 ? '#b91c1c' : '#94a3b8' }}>
          {isSentinelActive ? '✓ กรองระดับวิกฤต (G-I / 4-5)' : 'ระดับวิกฤต (G-I / 4-5)'}
        </div>
      </div>
    </div>
  );
}
